// utc-time.service.ts
import { Injectable } from '@angular/core';
import { CMSDynamicService } from './cms-service';


@Injectable({
  providedIn: 'root',
})
export class UtcTimeService {
  constructor(private cmsService: CMSDynamicService) {}

  /**
   * Backend’den UTC zamanı getirir
   */
  async fetchUtcTime(): Promise<Date | null> {
    try {
      // CMSDynamicService get metodunu kullanıyoruz
      const res: any = await this.cmsService.get(
        0,          // page
        0,          // size
        'Yoklama',  // controller
        'utc'       // action
      );

      if (res && res.utcDateTime) {
        return new Date(res.utcDateTime); // JS Date UTC olarak parse edilir
      }
    } catch (e) {
      console.error('UTC zamanı çekme hatası:', e);
    }

    return null;
  }
}
